module.exports = __webpack_public_path__ + "static/media/pc_icon_qr_code.819479c7.svg";